//# sourceMappingURL=common.mjs.map
/// <reference types="./common.d.mts" />
import * as $when from "../../altar/altar/when.mjs";
import * as $user_id from "../../data_types/data/auth/user_id.mjs";
import * as $data_source from "../../data_types/data/data_source.mjs";
import * as $user from "../../data_types/data/user.mjs";
import * as $colors from "../../ds/ds/colors.mjs";
import * as $copy_button from "../../ds/ds/components/copy_button.mjs";
import * as $label from "../../ds/ds/components/label.mjs";
import * as $l from "../../ds/ds/components/layout.mjs";
import * as $pp from "../../ds/ds/components/profile_picture.mjs";
import * as $display from "../../ds/ds/typography/display.mjs";
import * as $text from "../../ds/ds/typography/text.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $redraw from "../../redraw/redraw.mjs";
import * as $a from "../../redraw_dom/redraw/dom/attribute.mjs";
import * as $html from "../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../sketch/sketch/css.mjs";
import * as $length from "../../sketch/sketch/css/length.mjs";
import { percent, px } from "../../sketch/sketch/css/length.mjs";
import * as $h from "../../sketch_redraw/sketch/redraw/dom/html.mjs";
import { toList, isEqual } from "../gleam.mjs";

export function page_title(text) {
  let _pipe = $css.class$(toList([$css.compose($display.xs())]));
  return $h.div(_pipe, toList([]), toList([$h.text(text)]));
}

export function separator() {
  let _pipe = $css.class$(
    toList([
      $css.width(percent(100)),
      $css.height(px(1)),
      $css.background($colors.light.grey_200),
    ]),
  );
  return $h.hr(_pipe, toList([]));
}

export function name_small(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.regular)),
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(8)),
      $css.white_space("nowrap"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function underlined_title(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.xl($text.medium)),
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.gap(px(16)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function card() {
  return $css.class$(
    toList([
      $css.border("1px solid " + $colors.light.grey_400),
      $css.border_radius(px(8)),
      $css.padding(px(32)),
    ]),
  );
}

export function small_icon(child) {
  let _pipe = $css.class$(
    toList([
      $css.width(px(20)),
      $css.height(px(20)),
      $css.property("flex-shrink", "0"),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([child]));
}

function stacked_pictures(size, children) {
  let size$1 = $int.to_string(size);
  let _pipe = $css.class$(
    toList([
      $css.display("grid"),
      $css.grid_template_columns(("repeat(" + size$1) + ", 12px) 12px"),
      $css.transition("grid-template-columns .2s"),
      $css.hover(
        toList([
          $css.grid_template_columns(("repeat(" + size$1) + ", 24px) 0px"),
        ]),
      ),
    ]),
  );
  return $h.div(_pipe, toList([]), children);
}

export function stacked_avatars(users_id, users) {
  let firsts = $list.take(users_id, 4);
  let first_size = $list.length(firsts);
  let rest = $list.length($list.drop(users_id, 4));
  return $l.row(
    toList([$l.align("center"), $l.gap(8)]),
    toList([]),
    toList([
      stacked_pictures(
        first_size,
        $list.index_map(
          firsts,
          (user_id, index) => {
            let user = $list.find(
              users,
              (u) => { return isEqual(u.id, user_id); },
            );
            return $when.ok(
              user,
              (user) => {
                let start = $int.to_string(index + 1);
                let end = $int.to_string(index + 3);
                let col = (start + " / ") + end;
                return $html.div(
                  toList([
                    $a.style(toList([["grid-row", "1"], ["grid-column", col]])),
                  ]),
                  toList([
                    $pp.from_user(user.picture, user.initials, new $pp.Medium()),
                  ]),
                );
              },
            );
          },
        ),
      ),
      (() => {
        if (rest === 0) {
          return $h.none();
        } else {
          let rest$1 = rest;
          return $h.text("+" + $int.to_string(rest$1));
        }
      })(),
    ]),
  );
}

export function status_to_label(source) {
  let $ = source.status;
  if ($ instanceof $data_source.Pending) {
    return $label.current();
  } else if ($ instanceof $data_source.Verified) {
    return $label.success();
  } else if ($ instanceof $data_source.NotVerified) {
    return $label.neutral();
  } else if ($ instanceof $data_source.Archived) {
    return $label.neutral();
  } else if ($ instanceof $data_source.Outdated) {
    return $label.error();
  } else if ($ instanceof $data_source.Processing) {
    return $label.neutral();
  } else {
    return $label.error();
  }
}

export function bold(text) {
  return $h.span(
    $css.class$(toList([$css.font_weight("bold")])),
    toList([]),
    toList([$h.text(text)]),
  );
}

function copy_id_content(id) {
  let _pipe = $css.class$(
    toList([$css.overflow("hidden"), $css.text_overflow("ellipsis")]),
  );
  return $h.div(_pipe, toList([]), toList([$h.text(id)]));
}

export function copy_id() {
  return $redraw.compose(
    $copy_button.copy_button(),
    (copy_button) => {
      return $redraw.component_(
        "CopyID",
        (_use0) => {
          let id = _use0[0];
          let _pipe = $css.class$(
            toList([
              $css.display("flex"),
              $css.white_space("nowrap"),
              $css.gap(px(9)),
              $css.align_items("center"),
              $css.font_family("monospace"),
              $css.font_size(px(12)),
              $css.overflow("hidden"),
              $css.text_overflow("ellipsis"),
              $css.border("1px solid " + $colors.palette.grey_200),
              $css.border_radius(px(8)),
              $css.padding(px(4)),
              $css.padding_left(px(9)),
            ]),
          );
          return $h.div(
            _pipe,
            toList([]),
            toList([copy_id_content(id), copy_button($copy_button.content(id))]),
          );
        },
      );
    },
  );
}

function role_to_int(role) {
  if (role === "Super Admin") {
    return 0;
  } else if (role === "Admin") {
    return 1;
  } else if (role === "Proposal Manager") {
    return 2;
  } else if (role === "Content Curator") {
    return 3;
  } else if (role === "Contributor") {
    return 4;
  } else {
    return 5;
  }
}

export function compare_roles(r1, r2) {
  let r1$1 = role_to_int(r1);
  let r2$1 = role_to_int(r2);
  return $int.compare(r1$1, r2$1);
}

export function roles() {
  return $redraw.component_(
    "Roles",
    (_use0) => {
      let roles$1 = _use0[0];
      let $ = $redraw.use_state(false);
      let show_more = $[0];
      let set_show_more = $[1];
      let length = $redraw.use_memo(
        () => { return $list.length(roles$1); },
        [roles$1],
      );
      let roles$2 = $redraw.use_memo(
        () => { return $list.sort(roles$1, compare_roles); },
        [roles$1],
      );
      return $l.row(
        toList([$l.gap(4), $l.wrap("wrap")]),
        toList([]),
        toList([
          $redraw.fragment(
            $list.map(
              $bool.guard(
                show_more,
                roles$2,
                () => { return $list.take(roles$2, 2); },
              ),
              (role) => { return $label.label(toList([$label.content(role)])); },
            ),
          ),
          (() => {
            let $1 = length > 2;
            if ($1) {
              return $label.label(
                toList([
                  $label.on_click(() => { return set_show_more(!show_more); }),
                  $label.current(),
                  (() => {
                    if (show_more) {
                      return $label.content("Hide");
                    } else {
                      return $label.content("Show More");
                    }
                  })(),
                ]),
              );
            } else {
              return $h.none();
            }
          })(),
        ]),
      );
    },
  );
}

export function raw(text) {
  let _pipe = $css.class$(
    toList([
      $css.font_family("monospace"),
      $css.background($colors.palette.grey_100),
      $css.border("1px solid " + $colors.palette.grey_200),
      $css.border_radius(px(8)),
      $css.padding_("2px 4px"),
    ]),
  );
  return $h.span(_pipe, toList([]), toList([$h.text(text)]));
}

export function code(texts) {
  let _pipe = $css.class$(
    toList([
      $css.display("block"),
      $css.background($colors.palette.grey_100),
      $css.border("1px solid " + $colors.palette.grey_200),
      $css.padding(px(8)),
      $css.border_radius(px(8)),
      $css.font_family("monospace"),
      $css.white_space("pre-line"),
    ]),
  );
  return $h.code(_pipe, toList([]), texts);
}
